import { NgModule } from '@angular/core';
import { CpfPipe } from './cpf.pipe';
import { CnpjPipe } from './cnpj.pipe';
import { CustomCurrencyPipe } from './currency-pipe';

@NgModule({
  providers: [],
  declarations: [CpfPipe, CnpjPipe, CustomCurrencyPipe],
  imports: [],
  exports: [CpfPipe, CnpjPipe, CustomCurrencyPipe],
})
export class ApplicationPipesModule { }
